import { CorreoElectronico } from '@rpe/registro-personas-empresas-lib';

import { AnalisisLaboratorioEspecie } from '../entity-analisis-especie-laboratorio/analisis-laboratorio-especie.model';
import { Balanza } from '../entity-balanzas/balanzas.model';
import { DivisorMuestra } from '../entity-divisores-muestra/divisores-muestra.model';
import { EquipamientoLaboratorio } from '../entity-equipamientos-laboratorio/equipamientos-laboratorio.model';
import { Germinador } from '../entity-germinadores/germinadores.model';
import { Telefono } from '../../contactos/telefonos/telefonos.model';
import { DireccionGeografica } from '../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';

export interface Laboratorio {
  id: number;
  nombre: String;
  entidad_productiva_id: number;
  direccion_geografica: DireccionGeografica;
  telefonos: Telefono[];
  correos_electronico: CorreoElectronico[];
  balanzas: Balanza[];
  numero: number;
  germinadores: Germinador[];
  divisores_muestra: DivisorMuestra[];
  equipamientos: EquipamientoLaboratorio[];
  acreditado_nacional?: boolean,
  acreditado_mercosur?: boolean,
  analisis_especie: AnalisisLaboratorioEspecie[];
  estado_id: number;
}

export function createEmptyLaboratorio(): Laboratorio {
  return {
    id: null,
    nombre: null,
    entidad_productiva_id: null,
    numero: null,
    direccion_geografica: null,
    correos_electronico: null,
    telefonos: null,
    balanzas: null,
    germinadores: null,
    divisores_muestra: null,
    equipamientos: null,
    analisis_especie: null,
    estado_id: null,
  };
}

export function createLaboratorio(props: any): Laboratorio {
  return {
    ...createEmptyLaboratorio(),
    ...props
  };
}

export interface LaboratorioFormInput {
  /*action: FormActionType;
  especies: Especie[];
  tipos_divisor_muestra: TipoDivisorMuestra[];
  tipos_equipos_laboratorio: TipoEquipamientoLaboratorio[];
  tipos_analisis_laboratorio: TipoAnalisisLaboratorio[];*/
  laboratorios: Laboratorio[];
}

export function createEmptyLaboratorioFormInput(): LaboratorioFormInput {
  return {
    /*action: FormActionType.Add,
    especies: [],
    tipos_divisor_muestra: [],
    tipos_equipos_laboratorio: [],
    tipos_analisis_laboratorio: [],*/
    laboratorios: []
  };
}

export interface Equipamiento {
  balanzas: Balanza[];
  germinadores: Germinador[];
  divisores_muestra: DivisorMuestra[];
  equipamientos: EquipamientoLaboratorio[];
  analisis_especie: AnalisisLaboratorioEspecie[];
}

export function createEmptyEquipamiento(): Equipamiento {
  return {
    balanzas: null,
    germinadores: null,
    divisores_muestra: null,
    equipamientos: null,
    analisis_especie: null
  };
}

export function createEquipamiento(props: any): Equipamiento {
  return {
    ...createEmptyEquipamiento(),
    ...props
  };
}

export interface EquipamientoFormInput {
  equipamiento: Equipamiento;
  laboratorioId: number;
}
